<template>
  <v-card>
    <!-- {{editItem}} -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Passenger Biometric Finger</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editProjectBiometricForm" v-model="valid" lazy-validation>
        <v-flex md6>
          <v-menu
            v-model="fingerSchedueDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="editItem.biometric_finger_schedule_date"
                label="Biometric Finger Schedule Date"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="editItem.biometric_finger_schedule_date"
              @input="fingerSchedueDateMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-layout row wrap class="pb-0">
          <v-flex md6 class="pr-1">
            <v-menu
              v-model="visaIssueDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editItem.visa_issue_date"
                  label="Visa issue date *"
                  readonly
                  outline
                  v-on="on"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editItem.visa_issue_date"
                @input="visaIssueDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md6>
            <v-menu
              v-model="visaExpiryDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editItem.visa_expiry_date"
                  label="Visa Expiry date *"
                  readonly
                  outline
                  v-on="on"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editItem.visa_expiry_date"
                @input="visaExpiryDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  GENDERS,
  MEDICAL_STATUSES,
  FINGER_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
  COUNTRIES,
  NATIONALITIES,
  RELIGIONS,
  MARITAL_STATUSES,
  LANGUAGES,
} from "../../mdsir/const";
import {
  getTV,
  removeEmptyProps,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["editItem", "agents", "employers"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,

      contractDateMenu: false,
      dobDateMenu: false,
      visaIssueDateMenu: false,
      visaExpiryDateMenu: false,
      fingerSchedueDateMenu: false,
      trainingEndDateMenu: false,
      visaIssueDateMenu: false,
      flightDateMenu: false,
      COUNTRIES: COUNTRIES,
      NATIONALITIES: NATIONALITIES,
      RELIGIONS: RELIGIONS,
      MARITAL_STATUSES: MARITAL_STATUSES,
      LANGUAGES: LANGUAGES,
      passportIssueDateMenu: false,
      passportExpDateMenu: false,
    };
  },
  computed: {
    medicalStatuses() {
      return getTV(MEDICAL_STATUSES);
    },
    fingerStatuses() {
      return getTV(FINGER_STATUSES);
    },
    visaTypes() {
      return getTV(VISA_TYPES);
    },
    serviceTypes() {
      return getTV(SERVICE_TYPES);
    },
    agentsTV() {
      return getTV(this.agents, { textField: "name", valueField: "id" });
    },
    employersTV() {
      return getTV(this.employers, { textField: "name", valueField: "id" });
    },
    projectOwnersTV() {
      return getTV(PROJECT_OWNER, { isDeselect: false });
    },
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editProjectBiometricForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editProjectBiometricForm.reset();
    },
    resetValidation() {
      this.$refs.editProjectBiometricForm.resetValidation();
    },
    editItemDo() {
      if (this.$refs.editProjectBiometricForm.validate()) {
        this.actionButtonClicked = true;
        this.put(
          "/biometric_finger_details",
          removeEmptyProps(this.editItem, [
            "contract_date",
            "dob",
            "visa_issue_date",
            "flight_date",
            "medical_date",
            "mofa_date",
            "training_start_date",
            "training_end_date",
            "biometric_finger_schedule_date",
          ])
        ).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
